<template>
  <div class="koc-block koc-purchase-product-select-block">
    <div class="koc-full">
      <header
        v-if="title"
      >
        <section class="koc-header-main koc-header-secondary">
          {{ title }}
        </section>
      </header>
      <div class="koc-options">
        <label
          v-for="(option) in options"
          :key="option.handle"
          class="koc-option koc-ripple"
          :class="{ active: option.handle === selected }"
        >
          <div class="koc-check">
            <input
              :id="option.handle"
              :checked="option.handle === selected"
              type="radio"
              name="option"
              :value="option.handle"
              @click="change(option.handle)"
            >
            <div class="koc-box" />
          </div>
          <h2>
            <span class="koc-options-event-title">{{ option.option_name }} |</span>
            <span class="koc-options-event-price">{{ formatPrice(option.price_in_cents) }}</span>
          </h2>
          <div
            class="koc-options-event-description"
            v-html="option.description"
          />

        </label>
      </div>
    </div>
  </div>
</template>

<script src="./event-product-select.js"></script>
<style lang="scss" scoped src="./event-product-select.scss"></style>
